import script from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=af406d92&lang=css"

const __exports__ = script;

export default __exports__